import { convertCentToFahr } from 'utils/helpers/unitSystem';
import { truncateTo2dp } from 'utils/helpers/general';
import { useAppSelector } from 'store/hook';
import { useTranslation } from 'react-i18next';
import './Weather.css';

export const WeatherDisplay = ({ data }: any) => {
  const { t } = useTranslation();
  const {
    customer: { unitSystem },
  } = useAppSelector((state) => state.authReducer);

  const temperatureUnit = unitSystem === 'metric' ? 'C' : 'F';

  const weather = data?.weather;

  // Map API status to working icon
  const weatherIconMap: Record<string, string> = {
    Clear: 'https://openweathermap.org/img/wn/01d.png',
    Clouds: 'https://openweathermap.org/img/wn/03d.png',
    Rain: 'https://openweathermap.org/img/wn/09d.png',
    Snow: 'https://openweathermap.org/img/wn/13d.png',
    Thunderstorm: 'https://openweathermap.org/img/wn/11d.png',
    Drizzle: 'https://openweathermap.org/img/wn/10d.png',
    Mist: 'https://openweathermap.org/img/wn/50d.png',
  };

  if (!weather) return null;

  const iconUrl = weatherIconMap[weather.status] || weather.icon;

  return (
    <div className="header-center">
      <div className="weather-widget">
        <img
          className="weather-icon"
          src={iconUrl}
          alt={weather.description}
          style={{ width: '30px', height: '30px' }}
        />
        <div className="weather-info">
          <p style={{ fontSize: '11px' }}>
            {`Current: ${truncateTo2dp(
              unitSystem === 'metric'
                ? weather.degree
                : convertCentToFahr(weather.degree)
            )}°${temperatureUnit} | Min: ${truncateTo2dp(
              unitSystem === 'metric'
                ? weather.min
                : convertCentToFahr(weather.min)
            )}°${temperatureUnit} / Max: ${truncateTo2dp(
              unitSystem === 'metric'
                ? weather.max
                : convertCentToFahr(weather.max)
            )}°${temperatureUnit}`}
          </p>
          <p>•</p>
          <p style={{ fontSize: '11px' }}>
            {t('humidity')} {weather.humidity}%
          </p>
        </div>
      </div>
      <div className="location">
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clipRule="evenodd"
          />
        </svg>
        {`${data?.city || 'Unknown'}, ${data?.state || 'Unknown'}`}
      </div>
    </div>
  );
};
